import { useState } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'general',
    message: '',
    newsletter: false
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Aquí se implementaría el envío del formulario
    alert('¡Mensaje enviado correctamente! Te responderemos pronto.');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  return (
    <section id="contacto" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full text-sm font-medium mb-4">
            CONTACTO
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            ¿Necesitas ayuda?
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            Nuestro equipo está listo para asistirte las 24 horas del día
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
              Múltiples formas de contacto
            </h3>
            <p className="text-gray-600 dark:text-gray-300 mb-8">
              Elige la forma que prefieras para comunicarte con nosotros. Garantizamos respuesta rápida y personalizada.
            </p>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl text-blue-600 dark:text-blue-400"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-1">Email</h4>
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-1">support@AbiSoftexplorer.com</p>
                  <p className="text-xs text-gray-500">Respuesta en menos de 2 horas</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 dark:bg-green-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-chat-3-line text-xl text-green-600 dark:text-green-400"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-1">Chat en vivo</h4>
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-1">Disponible 24/7</p>
                  <p className="text-xs text-gray-500">Respuesta instantánea</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-xl text-purple-600 dark:text-purple-400"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-1">WhatsApp</h4>
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-1">+1 (555) 123-4567</p>
                  <p className="text-xs text-gray-500">Lun-Vie 9AM-6PM EST</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-cyan-100 dark:bg-cyan-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-twitter-line text-xl text-cyan-600 dark:text-cyan-400"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white mb-1">Twitter</h4>
                  <p className="text-gray-600 dark:text-gray-300 text-sm mb-1">@AbiSoftExplorer</p>
                  <p className="text-xs text-gray-500">Soporte público y privado</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-700">
              <div className="flex items-center space-x-2 text-blue-800 dark:text-blue-200">
                <i className="ri-time-line"></i>
                <span className="font-semibold text-sm">Tiempo de respuesta promedio: 1.5 horas</span>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-3">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Nombre completo
                  </label>
                  <div className="relative">
                    <i className="ri-user-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border-0 border-b-2 border-gray-200 dark:border-gray-600 bg-transparent focus:border-blue-500 dark:focus:border-blue-400 focus:outline-none transition-colors text-gray-900 dark:text-white"
                      placeholder="Tu nombre"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Email
                  </label>
                  <div className="relative">
                    <i className="ri-mail-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border-0 border-b-2 border-gray-200 dark:border-gray-600 bg-transparent focus:border-blue-500 dark:focus:border-blue-400 focus:outline-none transition-colors text-gray-900 dark:text-white"
                      placeholder="tu@email.com"
                    />
                  </div>
                </div>
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Asunto
                </label>
                <div className="relative">
                  <i className="ri-bookmark-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full pl-10 pr-8 py-3 border-0 border-b-2 border-gray-200 dark:border-gray-600 bg-transparent focus:border-blue-500 dark:focus:border-blue-400 focus:outline-none transition-colors text-gray-900 dark:text-white"
                  >
                    <option value="general">Consulta general</option>
                    <option value="technical">Soporte técnico</option>
                    <option value="billing">Facturación</option>
                    <option value="feature">Solicitud de característica</option>
                    <option value="business">Consulta empresarial</option>
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Mensaje
                </label>
                <div className="relative">
                  <i className="ri-message-line absolute left-3 top-4 text-gray-400"></i>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    maxLength={500}
                    rows={6}
                    className="w-full pl-10 pr-4 py-3 border-0 border-b-2 border-gray-200 dark:border-gray-600 bg-transparent focus:border-blue-500 dark:focus:border-blue-400 focus:outline-none transition-colors text-gray-900 dark:text-white resize-none"
                    placeholder="Describe tu consulta o problema..."
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1 text-right">
                    {formData.message.length}/500 caracteres
                  </div>
                </div>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="newsletter"
                  name="newsletter"
                  checked={formData.newsletter}
                  onChange={handleChange}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label htmlFor="newsletter" className="ml-3 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                  Acepto recibir actualizaciones y noticias por email
                </label>
              </div>

              <button
                type="submit"
                className="w-full py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg font-semibold rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                Enviar Mensaje
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}